export default "/images/vendor/flag-icon-css/flags/1x1/na.svg?27bc2313a9535106015ccb6e98c26b29";